<template>
  <!-- roll房管理-roll房列表-开奖历史 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="roll房开奖历史"
      width="800px"
      @close="closeDialog"
      center
    >
      <el-table :data="logData" v-loading="loading">
        <el-table-column prop="user_id" label="用户ID" align="center" />
        <el-table-column prop="get_amount" label="金额" align="center" />
        <el-table-column prop="created_at" label="时间" align="center" />
      </el-table>
      <p class="null_tips" v-if="!logData && !loading">暂无数据</p>

      <!-- 底部分页条 -->
      <el-pagination
          background
          :total="logDataMeta ? logDataMeta.total : 0"
          :current-page="logDataMeta ? logDataMeta.current_page : 1"
          :page-size="logDataMeta ? logDataMeta.per_page : 15"
          @current-change="handlLogPageChange"
        ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { delData, getApiData, patchData, postData } from '../../http'
import ImgUpload from '@/components/common/ImgUpload'

export default {
  components: {
    ImgUpload
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value:{
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//加载按钮动画
      query: {//查询条件
        page: 1
      },
      logData: undefined,//历史数据列表
      logDataMeta: undefined,//底部跳转页面条
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    redInfo:{
      get() {
        return this.value
      },
      set() {
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        // 打开弹窗显示数据
        this.getData()
      }
    }
  },
  created() {
  },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['getBoxCategories', 'getBoxGroup']),
    getData() {
      //获取开奖历史
      this.loading = true
      let params = {
        page: this.query.page
      }
      getApiData('red_inherit_record', params).then(res => {
        if (res) {
          this.logData = res.data
          //设置底部导航条数据
          this.logDataMeta=res
        }
      }).finally(() => {
        this.loading = false
      })

    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    },
    handlLogPageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}
</script>
<style lang="less" scoped>
.null_tips{
  text-align: center;
  line-height: 60px;
  color: #909399;
}
</style>